import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router, Route } from '@angular/router';
import {
  AlertService,
  GrowlType,
} from 'app/infrastructure/services/alert.service';
import { Translator } from 'angular-translator';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmacionModalComponent } from 'app/helpers/components/confirmationModal/confirmationModal.component';
import { ReportConfigurationService } from 'app/infrastructure/services/reportConfiguration.service';
import { ReportConfiguration } from 'app/infrastructure/model/interfaces/reportConfiguration.interface';

@Component({
  selector: 'sx-report-configuration-subscription-list',
  templateUrl: './report.configuration.subscription.list.component.html',
})
export class ReportConfigurationSubscriptionListComponent implements OnInit {
  organizationCode: string;
  subscriptionCode: string;
  channelCode: string;
  productCode: string;
  documentKind: string;
  preguntarSiDeseaBorrar = [];
  reportConfigurations: ReportConfiguration[] = new Array<
    ReportConfiguration
  >();

  constructor(
    private reportConfigurationSrv: ReportConfigurationService,
    private router: Router,
    private aRoute: ActivatedRoute,
    private alertService: AlertService,
    private translate: Translator,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.organizationCode = params['codorganizacion'];
      this.subscriptionCode = params['codsistema'];
      this.channelCode = params['codnegocio'];
      this.productCode = params['codproducto'];
      this.documentKind = params['documentKind'];

      this.reportConfigurationSrv
        .getAllSubscribed(
          this.organizationCode,
          this.subscriptionCode,
          this.channelCode,
          this.productCode
        )
        .subscribe((res) => (this.reportConfigurations = res));
    });
  }

  clickEdit(reportConfigurationId: string) {
    this.router.navigate(['.', reportConfigurationId], {
      relativeTo: this.aRoute,
    });
  }

  clickDelete(reportConfigurationId: string, name: string) {
    const modalRef = this.modalService.open(ConfirmacionModalComponent);
    const modalInstance = <ConfirmacionModalComponent>(
      modalRef.componentInstance
    );
    const text = <string>this.translate.instant('DISABLE_TEXT');

    modalInstance.titulo = `${text} ${name}?`;
    modalRef.result.then((confirmacion) => {
      this.reportConfigurationSrv
        .unsubscribe(
          reportConfigurationId,
          this.organizationCode,
          this.subscriptionCode,
          this.channelCode,
          this.productCode
        )
        .then((success) => {
          if (success) {
            this.alertService.showGrowl(
              {
                type: GrowlType.SUCCESS,
                body: 'SUCCESSFUL_DELETE_BUSINESS_LOGIC',
              },
              { name: name }
            );
          } else {
            this.alertService.showGrowl(
              {
                type: GrowlType.DANGER,
                body: 'COULD_NOT_DELETE_BUSINESS_LOGIC',
              },
              { name: name }
            );
          }
          this.reportConfigurations = this.reportConfigurations.filter(
            (f) => f.id !== reportConfigurationId
          );
        });
    });
  }

  isPolicy() {
    return this.documentKind === 'Policy';
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/reportConfiguration/subscribe/subscribe-list/report.configuration.subscription.list.component.ts